/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetLicenseIdentifiers = require('../services/GetLicenseIdentifiers');
var GetAllBondCompanies = require('../services/GetAllBondCompanies');
var GetAllBondType = require('../services/GetAllBondType');
var GetAllBondStatus = require('../services/GetAllBondStatus');

var NonDepNewLicenseBondView = require('../views/NonDepNewLicenseBondView');

module.exports = function(entityId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetLicenseIdentifiers(licenseId), GetAllBondCompanies(), GetAllBondType(), GetAllBondStatus())
    .done(function(licenseIdentifiers, entityBondCompanies, entityBondType, entityBondStatus) {
      NavUtils.navigate('nondep/entity/' + entityId + '/license/' + licenseId + '/add-bond');
      var data = {
        entityId: entityId,
        licenseId: licenseId,
        entityBondCompanies: entityBondCompanies,
        entityBondType: entityBondType,
        entityBondStatus: entityBondStatus,
        licenseIdentifiers: licenseIdentifiers
      };
      Scaffold.content.show(
        new NonDepNewLicenseBondView({
          model: new Backbone.Model(data)
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
